<template>
  <!-- <div v-if="allData.length"> -->
  <!-- <div id="table" ref="word"> -->
  <!-- <h2 class="text-center">قسم شؤون الموظفين والتدريب</h2>
        <h3 class="text-center">
          المتغيرات الشهرية لشهر
          {{ monthDate | moment("MMMM") | localeMonth }} لسنة
          {{ monthDate | moment("YYYY") }} م
        </h3> -->
  <div style="margin: 0px 30px; padding-top: 20px" class="report-15" dir="rtl">
    <div style="margin-top: 200px" v-if="pathLogo == m"></div>

    <div
      style="
        margin-top: 10px;
        margin-bottom: 35px;
        border: 0.5px solid rgb(67, 160, 71);
      "
      class="marginTop"
    >
      <md-card-header
        style="margin-bottom: 30px"
        class="md-card-header-text md-card-header-green"
      >
        <div class="card-text">
          <h4 class="title">
            الحصيلة الشهرية
            <span>
              من
              {{
                monthDate | moment("subtract", "1 month", "21 / MM / YYYY")
              }}</span
            >
            <span> إلى {{ monthDate | moment("20 / MM / YYYY") }} </span>
          </h4>
        </div>
      </md-card-header>

      <h2 class="text-center">قسم شؤون الموظفين والتدريب</h2>
      <h3 style="margin-bottom: 50px" class="text-center">
        الحصيلة الشهرية من {{ this.convert(DateFrom) }} الى
        {{ this.convert(DateTo) }}
      </h3>

      <md-card-content>
        <md-table
          :value="allData"
          :md-sort.sync="currentSort"
          :md-sort-order.sync="currentSortOrder"
          :md-sort-fn="customSort"
          class="paginated-table custome-paginated-table table-striped table-hover mt-25 font-size-style"
        >
          <md-table-row
            class="font-size-style-row"
            slot="md-table-row"
            slot-scope="{ item, index }"
          >
            <md-table-cell md-label="ر.ت">
              <p>{{ index + 1 }}</p>
            </md-table-cell>

            <md-table-cell class="w-200" md-label="الرقم المالي">
              <p>
                {{ item.financialNumber }}
              </p>
            </md-table-cell>

            <md-table-cell class="jobNumber" md-label="اسم الموظف">
              <p>
                {{ item.fullName }}
              </p>
            </md-table-cell>

            <md-table-cell class="w-200" md-label="نهاية الندب والتعاون">
              <p>
                {{ convert(item.delegationEndDate || "") }}
              </p>
            </md-table-cell>

            <md-table-cell class="w-100" md-label="الغياب">
              <p>
                {{ item.abcense }}
              </p>
            </md-table-cell>
            <md-table-cell md-label="إجازة مرضية">
              <p>
                {{ item.sickVacation }}
              </p>
            </md-table-cell>

            <md-table-cell class="w-200" md-label="إجازة طارئة">
              <p>
                {{ item.emergencyVacation }}
              </p>
            </md-table-cell>

            <md-table-cell class="w-200" md-label="مدة الإجازة السنوية">
              <p>
                {{ item.yearlyVacationDuration }}
              </p>
            </md-table-cell>

            <md-table-cell class="w-100" md-label="من تاريخ الإجازة">
              <div v-if="item.yearlyVacationDates.length">
                <span
                  style="margin-left: 3px"
                  v-for="(x, i) in item.yearlyVacationDates"
                  :key="i"
                >
                  {{ x.from | moment("YYYY-MM-DD") }}
                </span>
              </div>
              <div v-else>-</div>
            </md-table-cell>

            <md-table-cell class="w-100" md-label="إلى تاريخ الإجازة">
              <div v-if="item.yearlyVacationDates.length">
                <span
                  style="margin-left: 3px"
                  v-for="(x, i) in item.yearlyVacationDates"
                  :key="i"
                >
                  {{ x.to | moment("YYYY-MM-DD") }}
                </span>
              </div>

              <div v-else>-</div>
            </md-table-cell>

            <md-table-cell class="w-100" md-label="أيام الغياب">
              <span
                style="width: 20%"
                v-for="(x, i) in item.abcenseDates"
                :key="i"
              >
                {{ x | moment("DD") }}
                <span v-if="i != item.abcenseDates.length - 1">,</span>
              </span>
            </md-table-cell>

            <md-table-cell md-label="س إضافي عادي">
              <p>
                {{ item.normalOvertime }}
              </p>
            </md-table-cell>

            <md-table-cell class="w-200" md-label="س إضافي ممتاز">
              <p>
                {{ item.excellentOvertime }}
              </p>
            </md-table-cell>

            <md-table-cell md-label="س إضافي ممتاز"> </md-table-cell>
          </md-table-row>
        </md-table>
      </md-card-content>
    </div>
  </div>
</template>

<script>
import env from "../../../env";

export default {
  props: ["allData", "monthDate", "DateFrom", "DateTo"],
  filters: {
    localeMonth(value) {
      switch (value) {
        case "January":
          return "يناير";
          break;
        case "February":
          return "فبراير";
          break;
        case "March":
          return "مارس";
          break;
        case "April":
          return "أبريل";
          break;
        case "May":
          return "مايو";
          break;
        case "June":
          return "يونيو";
          break;
        case "July":
          return "يوليو";
          break;
        case "August":
          return "أغسطس";
          break;
        case "September":
          return "سبتمبر";
          break;
        case "October":
          return "أكتوبر";
          break;
        case "November":
          return "نوفمبر";
          break;
        case "December":
          return "ديسيمبير";
          break;

        default:
          break;
      }
      return;
    },
  },

  methods: {
    data() {
      return {
        count: 1,
        m: env.mTop(),
      };
    },
    convert(event) {
      try {
        let d = new Date(event);
        if (isNaN(d.getFullYear()) === true) {
          return "-";
        }
        return d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate();
      } catch (error) {}
    },
  },
};
</script>

<style>
.custome-paginated-table
  .md-table-head
  .md-table-head-container
  .md-table-head-label {
  font-size: 19px !important;
}
</style>
